import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class RestService {

    private baseUrl: string;
    private app: string;


    constructor(private httpClient: HttpClient) {
    }

    public get<T>(url: string): Promise<T> {
        return this.httpClient.get<T>(this.baseUrl + url).toPromise();
    }

    public delete<T>(url: string): Promise<T> {
        return this.httpClient.delete<T>(this.baseUrl + url).toPromise();
    }

    public post<T, U>(url: string, body: T, headers?: any): Promise<U> {
        return this.httpClient.post<U>(this.baseUrl + url, body, {headers: headers}).toPromise();
    }

    public put<T, U>(url: string, body: T): Promise<U> {
        return this.httpClient.put<U>(this.baseUrl + url, body).toPromise();
    }

    public setApp(app: string) {
        this.app = app;
        this.baseUrl = '/' + app + '/api/v1';
    }

    public getCurrentApp() {
        return this.app;
    }
}
